import script from "./ImgCropper.vue?vue&type=script&setup=true&lang=js"
export * from "./ImgCropper.vue?vue&type=script&setup=true&lang=js"

import "./ImgCropper.vue?vue&type=style&index=0&id=e1a5e76c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1a5e76c"]])

export default __exports__